import {Col, Container, Row} from "reactstrap";
import ReactTooltip from 'react-tooltip';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function Bio() {
    const skills1 = [
        {
            title: "HTML5",
            description: "HTML 5 is a revision of the Hypertext Markup Language (HTML), the standard programming language for describing the contents and appearance of Web pages.",
            icon: "html5",
            iconType: "fab",
            iconColor: "#e56026"
        },
        {
            title: "CSS3",
            description: "Cascading Style Sheets (CSS) is a style sheet language used for describing the presentation of a document written in a markup language.",
            icon: "css3",
            iconType: "fab",
            iconColor: "#2760e5"
        },
        {
            title: "Javascript",
            description: "JavaScript is a programming language that allows you to implement complex things on web pages — every time a web page does more than just sit there and display static information for you to look at — displaying timely content updates, or interactive maps, or animated 2D/3D graphics, or scrolling video jukeboxes, etc. — you can bet that JavaScript is probably involved.",
            icon: "js",
            iconType: "fab",
            iconColor: "#ead41c"
        },
        {
            title: "React",
            description: "React is an open-source front-end JavaScript library for building user interfaces or UI components.",
            icon: "react",
            iconType: "fab",
            iconColor: "#61dafb"
        },
        {
            title: "Angular",
            description: "Angular is a platform and framework for building single-page client applications using HTML and TypeScript. Angular is written in TypeScript. It implements core and optional functionality as a set of TypeScript libraries that you import into your applications.",
            icon: "angular",
            iconType: "fab",
            iconColor: "#b9032c"
        },
        {
            title: "Photoshop",
            description: "Adobe Photoshop is the predominant photo editing and manipulation software on the market. Its uses range from full featured editing of large batches of photos to creating intricate digital paintings and drawings that mimic those done by hand.",
            icon: "image",
            iconType: "far",
            iconColor: "#32cbe6"
        },
        {
            title: "SQL",
            description: "SQL is Structured Query Language, which is a computer language for storing, manipulating and retrieving data stored in a relational database. SQL is the standard language for Relational Database System.",
            icon: "database",
            iconType: "fas",
            iconColor: "#f1aa02"
        },
        {
            title: "PHP",
            description: "PHP (recursive acronym for PHP: Hypertext Preprocessor) is a widely-used open source general-purpose scripting language that is especially suited for web development and can be embedded into HTML.",
            icon: "php",
            iconType: "fab",
            iconColor: "#617ec2"
        },
        {
            title: "Java",
            description: "Java is a programming language and computing platform first released by Sun Microsystems in 1995. There are lots of applications and websites that will not work unless you have Java installed, and more are created every day. Java is fast, secure, and reliable. From laptops to datacenters, game consoles to scientific supercomputers, cell phones to the Internet, Java is everywhere!",
            icon: "java",
            iconType: "fab",
            iconColor: "#ed5328"
        },
        {
            title: "Spring",
            description: "The Spring Framework is an application framework and inversion of control container for the Java platform. The framework's core features can be used by any Java application, but there are extensions for building web applications on top of the Java EE platform.",
            icon: "leaf",
            iconType: "fas",
            iconColor: "#6cb33e"
        },
        {
            title: "ZK",
            description: "ZK is a UI framework that enables you to build amazing web and mobile applications without having to learn JavaScript or AJAX.",
            icon: "desktop",
            iconType: "fas",
            iconColor: "#0086ae"
        },
        {
            title: "Repo",
            description: "Git is a version control system for tracking changes in computer files and coordinating work on those files among multiple people. It is primarily used for source code management in software development, but it can be used to keep track of changes in any set of files. As a distributed revision control system it is aimed at speed, data integrity, and support for distributed, non-linear workflows.",
            icon: "git",
            iconType: "fab",
            iconColor: "#e44c30"
        },
    ];

    const skillsItems = skills1.map((skill) => {
        return (
            <Col key={skill.title} className="mb-3 text-center px-1">
                {/*<FontAwesomeIcon icon={[skill.iconType, skill.icon]} size="3x" color={skill.iconColor}*/}
                {/*                 data-tip={skill.description} data-place="right" data-type="info"*/}
                {/*                 data-multiline="true" data-class="my-react-tooltip"/>*/}
                <div className="bg-dark h-100 px-3 py-2">
                    <FontAwesomeIcon icon={[skill.iconType, skill.icon]} size="3x" color={skill.iconColor}/>
                    <div className="mt-1 mb-3 font-weight-bold" style={{color: skill.iconColor}}>{skill.title}</div>
                    {/*<ReactTooltip/>*/}
                    <p className="text-justify text-white">{skill.description}</p>
                </div>
            </Col>
        )
    });

    return (
        // fluid="md"
        <Container fluid className="background-main3 d-flex">
            <div className="justify-content-center align-self-center bg-semi-transparent w-100">
                <h2 className="text-center p-5 text-white">Skills</h2>
                <Row className="px-4" xs={1} md={3} lg={4}>
                    {skillsItems}
                </Row>
            </div>
        </Container>
    );
}

export default Bio;